import * as React from 'react';
import * as moment from 'moment-timezone';
import { useSelector } from 'react-redux';
import { getSelectedTeamAccount } from '../../../../../selectors/uiSelector';
import { Text } from '@doordash/design-language';
import { StoreImageWrapper, StoreImagePlaceholder, PhotoIcon, StoreResponsivePicture, PictureContainer, } from './GroupOrderEntryStyles';
import { useCalendarViewContext } from '../Calendar/CalendarViewContext';
import { CalendarStrings } from '../Calendar/CalendarStrings';
import { GroupOrderEntryStatus } from '../../../../../types/GloblalTypes';
import track from '../../../../../utils/track';
import { GroupOrdersAdminEvents } from '../../../../../constants/events';
import { validateUrl } from './EntryViewHelper';
import { EXTERNAL_ROUTES } from '../../../../../constants/values';
var contentStrings = CalendarStrings.groupOrderEntry;
var StoreImageView = function (props) {
    var isEmployeeView = useCalendarViewContext().isEmployeeView;
    var teamAccountId = useSelector(getSelectedTeamAccount);
    var entry = props.entry;
    var entryDate = moment(entry.checkoutTime).format('YYYY-MM-DD');
    var storeName = entry.store.name;
    var storeImgUrl = entry.store.imageUrl;
    var isValidatedImgUrl = validateUrl(storeImgUrl);
    var shouldShowGroupCartLink = !isEmployeeView &&
        entry.status ===
            GroupOrderEntryStatus.RECURRING_GROUP_ORDER_CALENDAR_STATUS_CART_CREATED_SUCCESS;
    var trackViewGroupCart = function () {
        track(GroupOrdersAdminEvents.VIEW_GROUP_CART, {
            team_account_id: teamAccountId,
            cart_id: entry.cart.id,
            date_clicked: entryDate,
            store_id: entry.store.id,
        });
    };
    var getStoreImage = function () { return (React.createElement(StoreResponsivePicture, { alt: storeName, baseURL: storeImgUrl })); };
    var getStoreImageWithCartLink = function () {
        // cannot use the go cart short link (entry.cart.link) directly
        // need to append the isDdfw flag to hide the address-out-of-range modal on Cart page
        var goCartLink = EXTERNAL_ROUTES.MARKETPLACE_CART + "/" + entry.cart.id + "/?isDdfw=true";
        return (React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: goCartLink, onClick: trackViewGroupCart },
            React.createElement(StoreResponsivePicture, { alt: storeName, baseURL: storeImgUrl })));
    };
    return (React.createElement(StoreImageWrapper, null,
        isValidatedImgUrl ? (React.createElement(PictureContainer, null, shouldShowGroupCartLink
            ? getStoreImageWithCartLink()
            : getStoreImage())) : (React.createElement(StoreImagePlaceholder, null,
            React.createElement(PhotoIcon, null),
            React.createElement(Text, { color: Text.Colors.TextDisabled, styles: Text.Styles.Caption2 }, contentStrings.imageComingSoon()))),
        props.children));
};
export default StoreImageView;
